import React, { useContext, useState, useRef, useEffect, useLayoutEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';

import { AuthContext } from "../context/AuthContext.jsx";
import { useRoom } from '../context/RoomContext.jsx';

import GameContainer from '../components/GameContainer.jsx';
import AvatarSelector from '../components/AvatarSelector.jsx';
import NickNameSelector from '../components/NickNameSelector.jsx';
import WaitingRoom from '../components/WaitingRoom.jsx';
import SplashScreen from '../components/SplashScreen.jsx';

const Game = () => {
	const { sessionInfo } = useContext(AuthContext);
	const { roomState } = useRoom();
	const [isRoomActive, setIsRoomActive] = useState(false);
	const [showSplash, setShowSplash] = useState(true);

	// Timer per nascondere lo splash screen dopo 5 secondi
	useEffect(() => {
		const timer = setTimeout(() => {
			setShowSplash(false);
		}, 5000);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (!sessionInfo) return;
		const colorPreset = (sessionInfo.template?.colorPreset || 'default').replace(/[A-Z]/g, m => "-" + m.toLowerCase());
		document.querySelector('body').className = '';
		document.querySelector('body').classList.add('trivia' + (colorPreset));
		//const gameContainer = document.getElementById('game-container')
		//if (gameContainer) gameContainer.style.minHeight = `calc(100vh - ${document.querySelector('footer')?.offsetHeight}px)`; 
	}, [sessionInfo]);

	const render = () => {

		if ( !sessionInfo.nickName && sessionInfo.sessionType === 1) {
			return <NickNameSelector />;
		}
		if (!sessionInfo.currentAvatarId && sessionInfo.sessionType === 1) {
			return <AvatarSelector />;
		}
		if ((roomState.status === "NotStarted" || !isRoomActive) && sessionInfo.sessionType === 1) {
			return <WaitingRoom setIsRoomActive={setIsRoomActive} />;
		}
		return <GameContainer />;
	}

	return (
		<>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick={false}
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="light"
			/>

			{sessionInfo && (
				<>
					{sessionInfo.template?.backgroundMediaId ?
						<img className="bg-image" src={`/api/trivia/media/${sessionInfo.template.backgroundMediaId}`} />
						: ""}
					{showSplash ? (
						<SplashScreen onClick={() => setShowSplash(false)} />
					) : (
						<>
							{render()}
						</>
					)}
				</>
			)}

		</>
	);
};

export default Game;
